<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-autocomplete
          v-model="model"
          :items="items"
          :loading="isLoading"
          :search-input.sync="search"
          hide-selected
          :item-text="displayAutocomplete"
          item-value="mail"
          label="Nom prénom"
          placeholder="Saisissez les premières lettres du nom"
          prepend-icon="mdi-database-search"
          return-object
          no-data-text="Non trouvé"
        ></v-autocomplete>
      </v-card-text>

      <template v-if="showDebug">
        <v-divider></v-divider>
        <v-expand-transition>
          <v-list v-if="model" class="primary lighten-3">
            <v-list-item v-for="(field, i) in fields" :key="i">
              <v-list-item-content>
                <v-list-item-title v-text="field.value"></v-list-item-title>
                <v-list-item-subtitle v-text="field.key"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expand-transition>
      </template>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!model" color="primary" @click="model = null">
          Effacer
          <v-icon right>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import ApiAutoCompleteRepository from "@/repositories/ApiAutoCompleteRepository";

export default {
  model: {
    event: "autocomplete"
  },
  props: ["source", "title", "subtitle", "debug"],
  data() {
    return {
      items: [],
      isLoading: false,
      model: null,
      search: null
    };
  },
  computed: {
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map(key => {
        return {
          key,
          value: this.model[key] || "n/a"
        };
      });
    },
    showDebug() {
      return this.debug !== undefined;
    }
  },

  watch: {
    search(val) {
      if (!val || val.length <= 2) return;

      if (val.indexOf("@") > -1) return; // Pour éviter la recherche après sélection d'un item (mail présent)

      this.getPersonsByStartName(this.search);
    },
    model() {
      this.$emit("autocomplete", this.model);
    }
  },
  methods: {
    displayAutocomplete(item) {
      return item.nom + " " + item.prenom + " - " + item.mail;
    },
    async getPersonsByStartName(startName) {
      this.isLoading = true;
      try {
        const referents = await ApiAutoCompleteRepository.getPersonsByStartName(
          startName,
          this.source
        );

        this.items = referents;
      } catch (error) {
        //console.log("Oups" + error);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
